import { render } from "./TextVideo.vue?vue&type=template&id=101b5433&scoped=true"
import script from "./TextVideo.vue?vue&type=script&lang=js"
export * from "./TextVideo.vue?vue&type=script&lang=js"

import "./TextVideo.vue?vue&type=style&index=0&id=101b5433&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-101b5433"]])

export default __exports__